import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ role, redirectTo = "/admin/login" }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#030f26]">
        <div className="text-[#a0aabf] text-sm tracking-widest uppercase">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to={redirectTo} replace />;
  if (role && user.role !== role && user.role !== "admin") {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
